export default "__VITE_ASSET___1WvEKBn__"